export default __webpack_public_path__ + "static/media/betting.b22bd386.png";